/* global Backbone, _ */

'use strict';

var Backbone        = require('backbone');
var _               = require('lodash');

module.exports = Backbone.Model.extend({

    apiUrl: window.location.protocol + '//tailor-dev.telescope.tv/1.0/jobs',

    defaults: {
        "actions": [{
            "type": "convert",
            "inputs": [{
                "type": "upload",
                "reference": "1"
            }],
            "output_details": [{
                "identifier": "1",
                "format": "mp4",
                "size": {
                    "type": "max_area",
                    "width": 1920,
                    "height": 1080
                }
            }]
            }, {
            "type": "thumbnail",
            "inputs": [{
                "type": "action_result",
                "reference": "1"
            }],
            "output_details": [{
                "identifier": "2",
                "format": "jpeg",
                "size": {
                    "type": "scale_width",
                    "width": 400
                },
                "keyframe": {
                    "type": "percent",
                    "value": 25
                }
            }]
            }, {
            "type": "flex",
            "overrides": [{
                "name": "image",
                "inputs": [{
                    "type": "action_result",
                    "reference": "2"
                }]
            }, {
                "name": "video",
                "inputs": [{
                    "type": "action_result",
                    "reference": "1"
                }]
            }]
        }],
        "flex": {
            "id": "12312",
            "topics": "1000180",
            "ruleset_collection_id": "0",
            "user_name": "Jon DoeFinal",
            "screen_name": "JonDoeFinal",
            "message": "Thumbnail and convert",
            "timestamp": "",
            "image": "",
            "video": "",
            "avatar": "",
            "user_score": "",
            "country": "USA",
            "state": "CA",
            "account_age": "",
            "user_lang": "English",
            "status_lang": "Ready",
            "profile_description": "profile description",
            "user_timezone": "PST",
            "custom_parameters": ""
        },
        /**
         * The number of seconds to wait before updating again.
         */
        updateFrequency: 5,
        /**
         *
         */
        failureCount: 0,
        /**
         * if updateFrequency is 5 and failureLimit is 60, this would be 5 minutes of polling
         */
        failureLimit: 60,
        /**
         *
         */
        pollTimer: null
    },

    //4c6f53ab-c4a9-462c-8bf3-8b32cad21d21
    /**
     * Initialize
     * @param  {Object} attributes [description]
     * @param  {Object} options    [description]
     */
    initialize: function(attributes, options) {
        this.auth_token = options.auth_token;
        if (typeof options.jobId !== 'undefined' && options.jobId) {
            this.jobId = options.jobId;
        }
        if(options.apiUrl && options.apiUrl!==''){
            this.apiUrl = options.apiUrl;
        }
        this.poll = options.poll || true;
    },

    /**
     * Return URL root
     * @return {String} [description]
     */
    urlRoot: function() {
        if(typeof this.jobId === 'undefined'){
            return this.apiUrl + '?Authorization=' + this.auth_token;
        } else {
            return this.apiUrl + '/' + this.jobId + '/flex?Authorization=' + this.auth_token;
        }
    },

    /**
     * Save
     * @param  {Objects} attributes [description]
     * @param  {Objects} options    [description]
     * @return {[type]}             [description]
     */
    save: function(attributes, options) {
        if(typeof this.auth_token === 'undefined' || this.auth_token === null) {
            console.warn('Tailor API requires an authentication token.');
            return;
        }

        if (!Backbone.$.support.cors && window.XDomainRequest) {
            //this.apiUrl = this.altUrl;
            this.trigger('unsupported_browser', this);
            console.warn('Browser does not support cross-domain File upload.');
            return;
        }
        if(typeof this.jobId === 'undefined'){
            options = {
            type: 'POST',
            dataType: 'json'
            };
        } else {
          options = {
            type: 'PUT',
            dataType: 'json'
          };
        }

        _.extend(options, {
          attrs: _.pick(this.toJSON(), 'actions', 'flex')
        })


        return Backbone.Model.prototype.save.call(this, attributes, options);
    },
    /**
     * check the status of the job, hitting the endpoint GET /jobs/{job_id}
     * @param  {[type]} options [description]
     * @return {[type]}         [description]
     */
    fetch: function(options) {

        options = options || {};

        if(typeof this.auth_token === 'undefined' || this.auth_token === null) {
            console.warn('Tailor API requires an authentication token.');
            return;
        }
        if(typeof this.jobId === 'undefined' || this.jobId === null) {
            console.warn('Tailor API GET jobs/job_id requires a job_id.');
            return;
        }

        var params = {
            url: this.apiUrl + '/' + this.jobId + '?Authorization=' + this.auth_token,
            dataType: 'json',
            type: 'GET',
            crossDomain: true
        };

        options = _.extend(params, options);

        if (this.poll) {
            this.pollData(options);
        }

        return Backbone.Model.prototype.fetch.call(this, options).fail(this.fetchError.bind(this));
    },
    /**
     * error handler
     * @param  {[type]} response   [description]
     * @param  {[type]} textStatus [description]
     * @return {[type]}            [description]
     */
    fetchError: function(jqXHR, textStatus, errorThrown) {
        console.log('fetchError', jqXHR, textStatus, errorThrown)
        if (textStatus !== 'abort') { // only handle errors, not intentionally terminated requests
            this.incrementFailureCounter();
            if (this.poll) this.pollData();
        }
    },
    /**
     * Sets the polling timer
     * @param  {[type]} options [description]
     * @return {[type]}         [description]
     */
    pollData: function(options) {
        if (this.get('failureCount') >= this.get('failureLimit')) return;

        clearTimeout(this.get('pollTimer'));

        this.set({
            pollTimer: setTimeout(_.bind(this.fetch, this, options), parseInt(this.get('updateFrequency'), 10) * 1000)
        });
    },
    /**
     * Stop polling and clear the timer
     * @return {[type]} [description]
     */
    stopPolling: function() {
        this.poll = false;
        var pollTimer = this.get('pollTimer');
        if(typeof pollTimer == 'number') clearTimeout(pollTimer);
        this.set({
          pollTimer: null,
          failureCount: 0
        });
    },
    /**
     * stores count of failed requests
     * @return {[type]} [description]
     */
    incrementFailureCounter: function (){
      this.set({ failureCount: (parseInt(this.get('failureCount'), 10) + 1) });
    }
});
